import React from "react";

import styles from "./Caption.css";

export default function Caption(props) {
  return React.createElement(
    "figcaption",
    { className: styles.caption },
    props.children
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Caption/Caption.js